import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  height: 100%;
  width: 100%;
  box-sizing: content-box;
  overflow: hidden;
  gap: 0 !important;
  
  > header {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${props => props.theme.cards.border};
    padding: 0 1.5rem 0 1.5rem;  
    
    > figure {
      z-index: 9;
      margin-top: -70px;
      margin-bottom: -15px;
      user-select: none;
      
      > img {
        width: 100%;
        user-select: none;
        //height: 155px;
      }
    }
  }
  
  > main {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1rem 1.5rem 4.5rem 1rem;
    min-height: 338px;
    height: fit-content;
    overflow-y: scroll;

    @media (max-width: 768px) {
      position: relative;
      padding: 1rem 1.5rem 3rem 1rem;
      min-height: 450px;

      > div:nth-child(1) {
        margin-top: 0;
      }

      > div:last-child {
        margin-bottom: 2rem;
      }
    }


    ::-webkit-scrollbar {
      width: 22px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 8px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      border-radius: 9999px;
      background-color: ${props => props.theme.colors.muted}50;
    }

    > header {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-top: -1rem;
      margin-bottom: 1.5rem;
      margin-right: -1rem;
      position: sticky;
      top: 0;
      background: ${props => props.theme.cards.primary};
      z-index: 9;
      padding: 0 0 1.5rem 0;

      > div {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        > h2 {
          font-size: 16px;
        }
  
        > main {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
          z-index: 1;
  
          > svg {
            margin-right: 0.75rem;
            position: absolute;
            color: ${props => props.theme.colors.muted}80;
            z-index: -1;
          }
        
          > select {
            padding: 0.5rem 2.5rem 0.5rem 0.7rem;
            background: ${props => props.theme.cards.primary};
            background: transparent;
            border: 1px solid ${props => props.theme.cards.border};
            box-shadow: ${props => props.theme.shadows.primary};
            border-radius: ${props => props.theme.radius.primary};
            color: ${props => props.theme.colors.white};
            width: 120px;
            height: 38px;
            font-size: 12px;
        
            -webkit-appearance: none;
            -moz-appearance: none;
            text-indent: 1px;
            text-overflow: '';
        
            > option {
              color: ${props => props.theme.colors.white};
              background: ${props => props.theme.modal.background};
            }
          }
        }
      }
    }

    > div {
      display: grid;
      align-items: center;
      grid-template-columns: 0.8fr 250px 1fr 1fr;
      width: 100%;
      padding: 0 0 0 1rem;

      &:last-child {
      }

      > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        margin: 0.5rem 0;
        
        > img {
          display: block;
          width: 30px;
          height: 30px;
          border-radius: 6px;
        }
      }

      > h5:nth-child(4) {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem -0.5rem -3rem 0;
  z-index: 999;

  > div {

    > svg {
      color: ${props => props.theme.colors.muted}80;
    }
  }


  > main {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    position: relative;

    > svg {
      margin-right: 0.75rem;
      position: absolute;
      color: ${props => props.theme.colors.muted}80;
      z-index: -1;
    }
  
    > select {
      padding: 0.5rem 2.5rem 0.5rem 0.7rem;
      background: ${props => props.theme.cards.primary};
      background: transparent;
      border: 1px solid ${props => props.theme.cards.border};
      border-radius: ${props => props.theme.radius.primary};
      color: ${props => props.theme.colors.white};
      width: 120px;
      height: 42px;
  
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 1px;
      text-overflow: '';
  
      > option {
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.modal.background};
      }
    }
  }

  > div {
    z-index: 999;
    margin: unset;
  }
`;

export const AvatarsContainer2 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  height: 350px;
  padding: 0 1rem;

  > main {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 1rem;
    margin: 4rem 0 0 0;

    > div {
      position: relative;
      border-radius: 80px 80px 0 0;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      //padding: 1rem 0.5rem;
      padding: 1rem;
      gap: 1rem;
      z-index: 1;

      > footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        text-align: center;
        gap: 0.5rem;

        > h2 {
          font-size: 14px;
          font-weight: bold;
          line-height: 0.9;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
        }

        > h3 {
          font-size: 10px;
          font-weight: 500;
          color: #fff;
        }
      }
    }

    > div:nth-child(1) {
      display: flex;
      background: #00dfcb;
      width: 100%;
      height: 82% !important;

    }

    > div:nth-child(2) {
      display: flex;
      background: #fe157e;
      width: 100%;
      height: 100% !important;
    }

    > div:nth-child(3) {
      display: flex;
      background: #72169b;
      width: 100%;
      height: 70% !important;
    }

    > div {
      width: auto !important;
      max-width: 110px !important;
    }
  }
`;

export const Thead = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 1rem 2rem;
  z-index: 999;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.cards.border};

  @media (max-width: 768px) {
    margin-top: 5rem;
  }
  
  > div {
    display: grid;
    align-items: center;
    grid-template-columns: 0.8fr 239px 1fr 1fr;
    width: 100%;

    > h5 {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
    }
    
    > h5:nth-child(4) {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const Footer = styled.footer`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  bottom: 0;
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 2rem;
  border-top: 1px solid ${props => props.theme.cards.border};
  gap: 0.5rem;
  overflow: hidden;
  border-radius: 0 0 12px 12px;
  background: ${props => props.theme.cards.primary};

> div {
    display: grid;
    align-items: center;
    grid-template-columns: 0.8fr 250px 1fr 1fr;
    width: 100%;

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      
      > img {
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 6px;
      }
    }

    > h5:nth-child(4) {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const HeaderMobile = styled.header`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  top: 0;
  background: ${props => props.theme.colors.gray}20;
  backdrop-filter: blur(8px) saturate(80%);
  width: 100%;
  padding: 0.75rem 2.75rem 0.75rem 2.5rem;
  border-bottom: 1px solid ${props => props.theme.colors.gray}35;
  gap: 0.5rem;
  overflow: hidden;
  z-index: 999;
  padding: 1rem !important;
  border-radius: 12px 12px 0 0;

  > div {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    > h2 {
      font-size: 16px;
    }

    > main {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      z-index: 1;

      > svg {
        margin-right: 0.75rem;
        position: absolute;
        color: ${props => props.theme.colors.muted}80;
        z-index: -1;
      }
    
      > select {
        padding: 0.5rem 2.5rem 0.5rem 0.7rem;
        background: ${props => props.theme.cards.primary};
        background: transparent;
        border: 1px solid ${props => props.theme.cards.border};
        box-shadow: ${props => props.theme.shadows.primary};
        border-radius: ${props => props.theme.radius.primary};
        color: ${props => props.theme.colors.white};
        width: 120px;
        height: 38px;
        font-size: 12px;
    
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
    
        > option {
          color: ${props => props.theme.colors.white};
          background: ${props => props.theme.modal.background};
        }
      }
    }
  }
`;

export const Medal = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  top: 20px;
  left: 17px;
  
  > img {
    width: 24px;
    height: 24px;
  }
`;